import React,{ useRef, useEffect } from "react";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";

const ScaleBarWidget = ({view}) => {
    
    const scaleBarWidgetDiv = useRef(null);
    
    useEffect(()=> {
        if(scaleBarWidgetDiv.current){
            const scaleBarWidget = new ScaleBar({
                container: scaleBarWidgetDiv.current,
                view: view,
                //style: "ruler",
                unit: "dual"
            }) 
            view.ui.add(scaleBarWidget,"bottom-right")
            
            return ()=> {
                scaleBarWidget.destroy()
            }
        }
        
    },[])
    
    return(
    <div ref={scaleBarWidgetDiv}></div>
    )   
}

export default ScaleBarWidget